import { Helmet } from "react-helmet-async";

const SITE = "https://sparkread.net";
const DEFAULT_OG =
  "https://images.unsplash.com/photo-1548690312-3b978c893df0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

/**
 * Per-page SEO. Renders:
 *  - <title>, description, keywords
 *  - canonical URL pointing to sparkread.net{path}
 *  - Open Graph + Twitter Card tags
 *  - Optional JSON-LD structured data
 *
 * Usage: <Seo title="..." description="..." path="/practice" />
 */
export default function Seo({
  title,
  description,
  path = "/",
  keywords,
  image = DEFAULT_OG,
  type = "website",
  jsonLd,
}) {
  const fullTitle = title
    ? `${title} | SparkRead`
    : "SparkRead — Adaptive AI literacy & test-prep platform";
  const url = `${SITE}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="SparkRead" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
